import React, { useEffect } from "react";
import label from "../../administration/labels/administration_en.json";

const MailSmsSend = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="dashboardContentArea">
      <h5> {label.MailSmsSend} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default MailSmsSend;
